import {EloquentSerializable} from "../interfaces/interfaces";
import {BaseModel} from "./base.model";
import {FormControl, FormGroup, Validators} from "@angular/forms";

export class ContactForm extends BaseModel {

    public name;
    public email;
    public subject;
    public message;

    public static readonly API_PREFIX: string = 'contact-form';


    form_group = new FormGroup({
        name: new FormControl(
            this.name,
            Validators.compose([
                Validators.required
            ])
        ),
        email: new FormControl(
            this.email,
            Validators.compose([
                Validators.email
            ])
        ),
        subject: new FormControl(
            this.subject,
            Validators.compose([
                Validators.required
            ])
        ),
        message: new FormControl(
            this.message,
            Validators.compose([
                Validators.required
            ])
        )

    });


    public getApiPrefix(): string {
        return ContactForm.API_PREFIX;
    }
}


// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/shared/eloquent/models/contact-form.model.ts